var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { injectIntl, defineMessages } from "react-intl";
import styled from "styled-components";
import GameCard from "../GameCard";
import Loader from "../../../Loader";
import { CardTitle, MoreButton } from "../styles";
import { clearOrderedGames } from "../../../../actions/games/creators";
var ORDERED_GAMES_LIMIT = 7;
var messages = defineMessages({
    more: {
        id: "games.More",
        defaultMessage: "Еще",
    },
});
var PreviewRow = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  overflow-x: auto;\n  gap: 12px;\n  padding: 12px 10px 16px;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"], ["\n  display: flex;\n  overflow-x: auto;\n  gap: 12px;\n  padding: 12px 10px 16px;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"])));
var PreviewCardWrap = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 0 0 auto;\n  width: 140px;\n\n  @media (max-width: 768px) {\n    width: 120px;\n  }\n\n  @media (max-width: 480px) {\n    width: 110px;\n  }\n"], ["\n  flex: 0 0 auto;\n  width: 140px;\n\n  @media (max-width: 768px) {\n    width: 120px;\n  }\n\n  @media (max-width: 480px) {\n    width: 110px;\n  }\n"])));
var GamesOrderedPreviews = /** @class */ (function (_super) {
    __extends(GamesOrderedPreviews, _super);
    function GamesOrderedPreviews() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openGroup = function (group) {
            var _a = _this.props, mode = _a.mode, history = _a.history;
            if (mode === "provider") {
                history.push("/games/providers/".concat(encodeURIComponent(group.Name)));
            }
            else {
                history.push("/games/types/".concat(group.Id));
            }
        };
        return _this;
    }
    GamesOrderedPreviews.prototype.componentWillUnmount = function () {
        this.props.clearOrderedGamesAction();
    };
    GamesOrderedPreviews.prototype.render = function () {
        var _this = this;
        var _a = this.props, groups = _a.groups, isLoading = _a.isLoading, darkTheme = _a.darkTheme, intl = _a.intl;
        if (isLoading && (!groups || !groups.length)) {
            return _jsx(Loader, {});
        }
        if (!groups || !groups.length) {
            return null;
        }
        return (_jsx("div", { children: groups.map(function (group) { return (_jsxs("div", { children: [_jsxs(CardTitle, __assign({ style: {
                            border: darkTheme && "none",
                            backgroundColor: darkTheme && "#585858",
                            color: darkTheme && "#fff",
                        }, onClick: function () { return _this.openGroup(group); } }, { children: [_jsx("span", { children: group.Name }), _jsx("div", { className: "arrow-right ".concat(darkTheme ? "dark" : "") })] })), _jsxs(PreviewRow, { children: [group.Games.map(function (game) { return (_jsx(PreviewCardWrap, { children: _jsx(GameCard, { game: game }) }, game.Id)); }), group.Games.length >= ORDERED_GAMES_LIMIT && (_jsxs(MoreButton, __assign({ darkTheme: darkTheme, style: { marginBottom: 0, height: "100%" }, onClick: function () { return _this.openGroup(group); } }, { children: [intl.formatMessage(messages.more), _jsx("div", { className: "arrow-right ".concat(darkTheme ? "dark" : "") })] })))] })] }, group.Id)); }) }));
    };
    return GamesOrderedPreviews;
}(React.Component));
var mapStateToProps = function (state) {
    var _a = state.games.orderedGames, groups = _a.groups, isLoading = _a.isLoading, mode = _a.mode;
    return {
        groups: groups,
        isLoading: isLoading,
        mode: mode,
        darkTheme: state.application.get("darkTheme"),
    };
};
var mapDispatchToProps = {
    clearOrderedGamesAction: clearOrderedGames,
};
export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(GamesOrderedPreviews)));
var templateObject_1, templateObject_2;



// WEBPACK FOOTER //
// ./src/components/games/components/GamesOrderedPreviews/GamesOrderedPreviews.jsx